module.exports = __webpack_public_path__ + "media/images/default/pages/public_sciences/main/4-1a16c91a75194929b378a0b71f352285.svg";